import { SpriteTextItemInterface } from '@/types/newTypes'
import clsx from 'clsx'
import React from 'react'

interface SecurityAndPrivacyProps {
  secondary?: boolean
}

const SecurityAndPrivacy = (props: SecurityAndPrivacyProps) => {
  const items: SpriteTextItemInterface[] = [
    {
      vectorId: '#guard-mini',
      text: '100% Private & Secure',
    },
    {
      vectorId: '#lock',
      text: 'Advanced Encryption for Photo Safety',
    },
  ]

  return (
    <section
      className={clsx(
        'relative flex justify-center items-center gap-[15px] mb-12 after:absolute dark:after:bg-securityPrivacyBg after:w-[315px] after:h-[300px] after:-bottom-10 after:right-0 after:bg-[right_center] after:bg-no-repeat',
        {
          'px-0.5 after:hidden': props.secondary,
          'px-4': !props.secondary,
        },
      )}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="flex max-w-[164px] flex-row gap-1 h-11 bg-grayGradientLight dark:bg-transparent dark:bg-grayGradient rounded-xl z-[1] items-center justify-between box-border p-2"
        >
          <svg width={24} height={24}>
            <use href={`/svg/sprite.svg${item.vectorId}`}></use>
          </svg>
          <p className="text-S">{item.text}</p>
        </div>
      ))}
    </section>
  )
}

export default SecurityAndPrivacy
